import { ReactNode } from 'react';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { Box, CircularProgress, Tooltip } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { isEmpty } from 'remeda';

import { Text } from '~/components/ui/text';

import { useStyles } from './pieChartCard.styles';

type PieChartCardProps = {
  title: string;
  tooltip?: string;
  isLoading: boolean;
  isFetching: boolean;
  data: { label: string; value: number }[];
};

export function PieChartCard({ title, tooltip, data, isFetching, isLoading }: PieChartCardProps) {
  const styles = useStyles();

  const content = isEmpty(data) ? (
    <Box sx={styles.empty}>
      <Text variant="input15" sx={{ color: '#6D6D6D', textAlign: 'center' }}>
        Not enough data to show statistics.
      </Text>
    </Box>
  ) : (
    <PieChart
      colors={['#39B75F', '#FF8F44', '#2196F3', '#FFB400', '#663C00', '#014361', '#9C27B0']}
      series={[
        {
          paddingAngle: 5,
          innerRadius: 60,
          outerRadius: 80,
          data,
        },
      ]}
      height={200}
    />
  );
  return (
    <Box sx={{ position: 'relative' }}>
      {isFetching && !isLoading && <CircularProgress sx={styles.loader} size={60} />}
      <Box sx={styles.cardContainer(isFetching)}>
        <Text variant="h3">
          {title}
          {tooltip && (
            <Tooltip
              title={tooltip}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: '#313031',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '15px',
                    maxWidth: '400px',
                    padding: '8px 16px',
                  },
                },
              }}
            >
              <HelpRoundedIcon sx={styles.tooltipIcon} />
            </Tooltip>
          )}
        </Text>
        <Box sx={styles.content}>{isLoading ? <CircularProgress size={60} /> : content}</Box>
      </Box>
    </Box>
  );
}
